export const EPOCH_SIZES: { label: string; inSeconds: number }[] = [
  { label: '30 s', inSeconds: 30 },
  { label: '60 s', inSeconds: 60 },
  { label: '2 min', inSeconds: 120 },
  { label: '5 min', inSeconds: 300 },
  { label: '10 min', inSeconds: 600 },
  { label: '30 min', inSeconds: 1800 }
];

export const INVALID_VALUE_TEXT = '-';

export const DEFAULT_TIME_FORMATS = {
  secondsFormat: '.1~f',
  invalidValueText: 'Invalid time'
};

export const DEFAULT_DATE_FORMAT = '%Y-%m-%d';

export const INVISIBLE_SIMPLE_SIGNAL = [
  'Nasal_pressure',
  'Resp_flow',
  'ECG',
  'EMG_mass_R',
  'EMG_mass_L',
  'Heart_rate'
];

export const INVISIBLE_SIGNAL = ['Position_mapped'];

export const INVISIBLE_SIGNAL_COLOR = ['Sleep_Stages'];
